import { Slide } from "@jelly/lesson";
import config from "appConfig";

import { task as task04 } from "../../../../../task/course-05/lesson-12/task-04";

const task: Slide = {
  titleHtml: "If the ventillation source is turned off in the room the NR curve is:",
  description: "Select the correct answer.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/12/task/task-4.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task04.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
